import { getListBrowserStore } from '@ts-private/list-browser';
import { reactiveStore } from '@ts-private/reactive-store';

export const leasingIncomeSchemasStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'LeasingIncomeSchema.Code',
      type: 'text'
    },
    {
      name: 'name',
      caption: 'LeasingIncomeSchema.Name',
      type: 'text'
    },
    {
      name: 'isActive',
      caption: 'LeasingIncomeSchema.IsActive',
      type: 'boolean'
    },
    {
      name: 'stateId',
      caption: 'LeasingIncomeSchema.State',
      type: 'select',
      underlyingType: 'number'
    }
  ],
  orderByFields: [
    {
      caption: 'LeasingIncomeSchema.Name',
      value: 'Name'
    },
    {
      caption: 'LeasingIncomeSchema.Code',
      value: 'Code'
    }
  ],
  pager: {
    orderBy: 'Name',
    direction: 'asc'
  }
});

export const stateHistoryLeasingIncomeSchemaId = reactiveStore(null);
